import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  getCurrentSubscription,
  toPayload,
} from 'pwa/helpers/pushNotifications';
import { registerPushSubscription } from 'shared/hooks/api/pushSubscriptions';

/**
 * Registers this device again each time a signed-in user opens the app.
 * The API drops devices it has not seen for 60 days, so an app that is used
 * keeps receiving push. It never asks for permission itself: only a device
 * that already allowed push and is already subscribed is sent.
 */
export default function usePushSubscriptionRefresh(userId?: string): void {
  useEffect(() => {
    if (!userId || !('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;

    getCurrentSubscription()
      .then((subscription) =>
        subscription
          ? registerPushSubscription(toPayload(subscription))
          : undefined
      )
      .catch((error) =>
        Sentry.captureException(error, { tags: { feature: 'push' } })
      );
  }, [userId]);
}
